<template>
  <div
    class="VizGallery--touch"
    :style="{
      height: height - 40 + 'px',
      zIndex: isPaintingDetailOpen ? 10000 : 100
    }"
  >
    <div
      class="VizGallery--touch__header"
      @click="
        setNewQuery(getPrevVizElement.depth, getPrevVizElement.data.id, 'up')
      "
    >
      <svgicon
        class="icon-arrow-up"
        icon="icon-arrow-up"
        width="12"
        height="12"
      ></svgicon>
      <transition name="fade" mode="out-in">
        <span :key="metadata.id">{{
          getPrevVizElement ? getPrevVizElement.data.name : "-"
        }}</span></transition
      >
    </div>
    <transition :name="'slide-fade-' + transitionDirection" mode="out-in">
      <div class="VizGallery--touch__body" :key="metadata.id">
        <!--         <div class="VizGallery--touch__title">{{ metadata.name }}</div>
 -->
        <div
          class="VizGallery--touch__gallery"
          :class="{ 'no-image': imageToRender.length < 1 }"
        >
          <SliderGallery
            :dataset="metadata"
            v-if="imageToRender && imageToRender.length > 0"
          >
            <div
              class="image-card"
              v-for="el in imageToRender"
              :key="el.id + '-image'"
              :style="{
                backgroundImage: `url(${assetsPaths.imagesPath}${
                  $tvaMq === 'mobile' ? '500' : '1280'
                }/${el.id}.jpg)`
              }"
              @click="openDetail(el)"
            >
              <div
                :style="{
                  backgroundImage: `url(${assetsPaths.imagesPath}500/${el.id}.jpg)`
                }"
                class="paint"
                :class="{ blurred: el.downloaded === 'true (look S)' }"
              ></div>
              <div
                class="img-container__disclaimer"
                v-if="el.downloaded === 'true (look S)'"
              >
                <svgicon
                  class="icon-eye-slashed"
                  icon="icon-eye-slashed"
                  width="31"
                  height="31"
                ></svgicon>
                <span>{{ content.rights_disclaimer }}</span>
              </div>
              <div
                class="img-container"
                :class="{ blurred: el.downloaded === 'true (look S)' }"
              >
                <div class="title">
                  {{
                    $tvaMq === "mobile"
                      ? truncateString(el.titolo_opera, 25)
                      : truncateString(el.titolo_opera, 55)
                  }}
                </div>
                <div class="author">
                  {{
                    $tvaMq === "mobile"
                      ? truncateString(el.autore, 20)
                      : truncateString(el.autore, 40)
                  }}
                </div>
              </div>
            </div>
            <div class="image-card upload">
              <div
                class="placeholder"
                @click="
                  $router.push({
                    name: 'upload'
                  })
                "
              >
                <svgicon
                  class="icon-plus"
                  icon="icon-plus"
                  width="13"
                  height="13"
                ></svgicon>
                <div class="title">{{ content.report.title }}</div>
                <div class="author">{{ content.report.dida }}</div>
              </div>
            </div>
          </SliderGallery>
          <div class="image-card upload" v-else>
            <div
              class="placeholder"
              @click="
                $router.push({
                  name: 'upload'
                })
              "
            >
              <svgicon
                class="icon-plus"
                icon="icon-plus"
                width="13"
                height="13"
              ></svgicon>
              <div class="title">{{ content.report.title }}</div>
              <div class="author">{{ content.report.dida }}</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <TvaAudioPlayerTouch
      :source="audioSource"
      :start="begin"
      :end="finish"
      :meta="metadata"
      :testWatcher="isGalleryOpen"
      :content="content"
      @clickInfo="toggleInfo()"
    />
    <div
      class="VizGallery--touch__footer"
      @click="
        setNewQuery(getNextVizElement.depth, getNextVizElement.data.id, 'down')
      "
    >
      <span>{{ getNextVizElement ? getNextVizElement.data.name : "-" }}</span>
      <svgicon
        class="icon-arrow-down"
        icon="icon-arrow-down"
        width="12"
        height="12"
      ></svgicon>
    </div>
    <PaintingDetailDesktop
      v-if="isPaintingDetailOpen && $tvaMq === 'desktop'"
      @close="closeDetail"
      :info="selectedDetail"
    />
    <PaintingDetailTouch
      v-if="isPaintingDetailOpen && $tvaMq !== 'desktop'"
      @close="closeDetail"
      :info="selectedDetail"
    />
    <Metadata v-if="metadataOpen" @close="toggleInfo()" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { truncateString } from "@/utilities/functions/stringUtils";
import TvaAudioPlayerTouch from "@/components/TvaAudioPlayerTouch";
import SliderGallery from "@/components/main-viz/SliderGallery";
import PaintingDetailDesktop from "@/components/main-viz/PaintingDetailDesktop";
import PaintingDetailTouch from "@/components/main-viz/PaintingDetailTouch";
import assetsPaths from "@/assets/assetsPaths.js";
import Metadata from "@/components/main-viz/Metadata";
import "@/compiled-icons/icon-arrow-down";
import "@/compiled-icons/icon-arrow-up";
import "@/compiled-icons/icon-plus";
import "@/compiled-icons/icon-eye-slashed";

export default {
  mounted() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    this.height = vh * 100;
    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      this.height = vh * 100;
    });
    window.addEventListener("orientationchange", () => {
      let vh = window.innerHeight * 0.01;
      this.height = vh * 100;
    });
    let query = this.$route.query;
    if (query && query.detail) {
      let imageToOpen = this.metadata.metadata.images.find(
        (x) => x.id === query.detail
      );
      this.openDetail(imageToOpen);
    }
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      isPaintingDetailOpen: false,
      selectedDetail: null,
      metadataOpen: false,
      assetsPaths,
      height: 0,
      transitionDirection: "up"
    };
  },
  computed: {
    content() {
      return this.$ml.get("gallery");
    },
    dataToRender() {
      return { ...this.metadata };
    },
    imageToRender() {
      let immages = this.dataToRender.metadata.images.filter(
        (el) => el.downloaded !== "false"
      );

      for (let el in immages)
        immages[el].downloaded === "true (look S)"
          ? immages.push(immages.splice(el, 1)[0])
          : 0;

      return immages;
    },
    audioSource() {
      let folder = "";
      let cantica = this.metadata.id.split("-")[0];
      if (cantica == 2) {
        folder = "A_inferno/";
      } else if (cantica == 1) {
        folder = "B_purgatorio/";
      } else {
        folder = "C_paradiso/";
      }
      let path =
        assetsPaths.audioPath +
        folder +
        "canto-" +
        this.metadata.metadata.canto +
        ".mp3";
      return path;
    },
    begin() {
      return this.metadata.metadata.in_audio_petrocchi;
    },
    finish() {
      return this.metadata.metadata.a_audio_petrocchi;
    },
    ...mapGetters(["getNextVizElement", "getPrevVizElement"])
  },
  methods: {
    toggleInfo() {
      return (this.metadataOpen = !this.metadataOpen);
    },
    truncateString,
    openDetail(obj) {
      this.selectedDetail = obj;
      this.isPaintingDetailOpen = true;
      this.$router.push({
        query: {
          ...this.$route.query,
          detail: obj.id
        }
      });
    },
    closeDetail() {
      this.isPaintingDetailOpen = false;
    },
    setNewQuery(type, id, direction) {
      this.transitionDirection = direction ? direction : "up";
      this.$router.push({
        query: {
          ...this.$route.query,
          type: type,
          id: id
        }
      });
    }
  },
  props: ["metadata", "isGalleryOpen"],
  components: {
    SliderGallery,
    PaintingDetailDesktop,
    TvaAudioPlayerTouch,
    PaintingDetailTouch,
    Metadata
  }
};
</script>
<style lang="scss" scoped>
.VizGallery--touch {
  position: absolute;
  width: 100%;
  background: linear-gradient(
    180deg,
    #96c2c4 -3.84%,
    #bea95e 49.07%,
    #573c46 106.58%
  );
  color: $white;
  top: 40px;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  align-items: center;
  z-index: $z-e;
  touch-action: none;
  &__title {
    text-align: center;
    color: $white;
    @include pS;
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translate(-50%, 0);
  }
  &__header,
  &__footer {
    height: 60px;
    width: 100%;
    border-bottom: 1px solid $white-50;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @include ButtonS;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
    .icon-arrow {
      &-down {
        fill: white;
        margin-top: 5px;
      }
      &-up {
        fill: white;
        margin-bottom: 5px;
      }
    }
  }
  &__footer {
    border-bottom: none;
    border-top: 1px solid $white-50;
  }
  &__body {
    width: 100%;
    height: calc(100% - 170px);
    display: flex;
    flex-direction: row;
    position: relative;
  }
  &__gallery {
    height: 100%;
    width: 100%;
    .image-card {
      height: 80%;
      /*  padding: 0 100px; */
      width: 70%;
      margin: 0 20px;
      /* padding: 0 20px; */
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      .paint {
        height: 100%;
        width: 100%;
        position: absolute;
        background-position: center; /* Center the image */
        background-repeat: no-repeat; /* Do not repeat the image */
        background-size: cover; /* Resize the background image to cover the entire container */
        // &.blurred {
        //   filter: brightness(50%) blur(4px);
        // }
      }
      img {
        max-width: 100%;
        max-height: 100%;
        height: unset;
        position: relative;
      }
      .img-container {
        position: relative;
        height: 100%;
        text-align: center;
        box-shadow: 0px 12px 25px 1px rgb(0 0 0 / 50%);
        .title {
          @include HH5;
          color: $white;
          position: absolute;
          text-align: center;
          bottom: 38px;
          left: 50%;
          transform: translate(-50%, 0);
          width: 80%;
          z-index: $z-c;
        }
        .author {
          @include pS;
          text-align: center;
          color: $white;
          position: absolute;
          bottom: 13px;
          left: 50%;
          transform: translate(-50%, 0);
          width: 80%;
          z-index: $z-c;
        }
        &.blurred {
          &::after {
            z-index: $z-none;

            top: 0;
            left: 0;
            content: "";
            display: none;
          }
        }
        &::after {
          z-index: $z-none;
          pointer-events: none;
          position: absolute;
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
          content: "";
          background-image: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0),
            rgba(0, 0, 0, 0.79)
          );
        }
        &__disclaimer {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 80%;
          margin: 0 10%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          @include pS;
          .icon-eye-slashed {
            fill: none;
            stroke: $white;
          }
          span {
            text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
          }
        }
      }
      &.upload {
        .placeholder {
          height: 100%;
          width: 100%;
          border: solid 2px $white;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: center;
          background-color: $black-10;
          position: relative;
          box-shadow: 0px 12px 25px 1px rgb(0 0 0 / 50%);
          .title {
            @include HH5;
            color: $white;
            margin-bottom: 5px;
            text-align: center;
          }
          .author {
            @include pS;
            text-align: center;
            color: $white;
            max-width: 80%;
            margin-bottom: 15px;
          }
          .icon-plus {
            stroke: $white;
            position: absolute;
            top: 50%;
            transform: translate(0, -50%);
          }
        }
      }
    }
    &.no-image {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

//Animazioni gallery
.slide-fade-up-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-up-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-up-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(20px);
  opacity: 0;
}
.slide-fade-up-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-20px);
}

.slide-fade-down-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-down-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-down-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-20px);
  opacity: 0;
}
.slide-fade-down-leave-to {
  transform: translateY(20px);
}

//Animazioni testi
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
